import {
  useRemoteStorage,
  WHATS_NEW_EARNINGS_TYPES,
  WHATS_NEW_INCLUDE_COMPETITORS,
  WHATS_NEW_INSIGHT_TYPES,
  WHATS_NEW_PERIOD,
  WHATS_NEW_SELECTED_WATCHLISTS,
  WHATS_NEW_SUMMARY_TYPES,
} from '~/hooks/use-remote-storage';

import { DEFAULT_WHATS_NEW_PERIOD } from '../types';

export const useWhatsNewSettings = () => {
  const items = useRemoteStorage(state => state.items);
  //TODO- remove types when stream v2 and catalysts are enabled
  return {
    selectedWatchlists: items?.[WHATS_NEW_SELECTED_WATCHLISTS],
    period: items?.[WHATS_NEW_PERIOD] ?? DEFAULT_WHATS_NEW_PERIOD,
    includeCompetitors: items?.[WHATS_NEW_INCLUDE_COMPETITORS],
    analysisTypes: items?.[WHATS_NEW_INSIGHT_TYPES],
    earningsTypes: items?.[WHATS_NEW_EARNINGS_TYPES],
    summaryTypes: items?.[WHATS_NEW_SUMMARY_TYPES],
  };
};
